import React from 'react';
import { createRoot } from 'react-dom/client';
import 'react-toastify/dist/ReactToastify.min.css';
import packageJson from '../package.json';
import App from './App';
import './components/layout/style.global.scss';

const root = createRoot(document.querySelector('#root') as HTMLElement);
root.render(<App />);
document.body.setAttribute('app-ver', packageJson.version);
